import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { ThemeContext } from 'utils/theme';
import QuoteSectionModel from 'models/QuoteSection';

import Quote from './styled/Quote';

export default class QuoteSection extends PureComponent {


  static defaultProps = {
  };

  static contextType = ThemeContext;

  render() {
    const { className, contents } = this.props;

    return (
      <Quote className={className} theme={this.context}>{contents}</Quote>
    );
  }
}
